import client from './client'

export default {
  async receiveCoupon (templateId) {
    const url = '/coupon/receive'
    const res = await client.get(url, {
      params: {
        templateId
      }
    })
    return res.data
  },
  async couponCheck (templateId) {
    const url = '/coupon/receive/check'
    const res = await client.get(url, {
      params: {
        templateId
      }
    })
    return res.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/coupon.js